import { vnModule_knockoutJS } from '../../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { header } from '../header';
import { adminRecruitingQuestionEdit_template } from '../../components/templates/recruiting/adminRecruitingQuestionEdit_template';
import { hideLoadingOverlay, showLoadingOverlay } from '~/utils/listLoading';
export class admin_question_edit_base extends vnModule_knockoutJS {
    getModuleName() {
        return this.getConfig().moduleName;
    }
    buildContent() {
        const config = this.getConfig();
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle(config.headerTitle);
        this.tpl = new adminRecruitingQuestionEdit_template('adminRecruitingQuestionEditTemplate', this.viewModel, this);
        this.tpl.setEditorOptions(config.templateOptions || {});
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    fillPage() {
        showLoadingOverlay(this.tpl.builtTemplate, 'Loading question...');
        this.XHRHdl = new XMLHttpRequestHandler(this.getConfig().referencesUrl, [], this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesReturn;
        this.XHRHdl.execute();
    }
    onReferencesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                obj.tpl.setReferences(responseParsed);
                obj.loadQuestion();
            });
            if (req.request.readyState === 4 && req.request.status !== 0 && !obj.getQuestionId()) {
                hideLoadingOverlay(obj.tpl.builtTemplate);
            }
        };
    }
    loadQuestion() {
        const questionId = this.getQuestionId();
        if (!questionId) {
            this.tpl.setQuestion(this.getNewQuestionDefaults());
            hideLoadingOverlay(this.tpl.builtTemplate);
            return;
        }
        this.XHRHdl = new XMLHttpRequestHandler(this.getConfig().questionUrl + questionId, [], this);
        this.XHRHdl.onReadyStateFunction = this.onQuestionReturn;
        this.XHRHdl.execute();
    }
    onQuestionReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                obj.tpl.setQuestion(responseParsed);
            });
            if (req.request.readyState === 4 && req.request.status !== 0) {
                hideLoadingOverlay(obj.tpl.builtTemplate);
            }
        };
    }
    async saveQuestion() {
        const config = this.getConfig();
        const payload = this.getSavePayload();
        if (!payload.configuration.label) {
            alert('Display text is required.');
            return;
        }
        if (!payload.configuration.inputId) {
            alert('Question type is required.');
            return;
        }
        showLoadingOverlay(this.tpl.builtTemplate, 'Saving question...');
        const response = await fetch(config.saveUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });
        const result = await response.json();
        hideLoadingOverlay(this.tpl.builtTemplate);
        if (!response.ok || Number(result.status || 0) !== 200) {
            alert(result.message || config.missingSaveMessage);
            return;
        }
        page(this.getSavedRoute(Number(result.objectId || 0)));
    }
    async deleteQuestion() {
        const config = this.getConfig();
        const questionId = this.getQuestionId();
        if (!config.deleteUrl || !questionId || !confirm(config.deleteConfirmMessage || 'Delete this question?')) {
            return;
        }
        showLoadingOverlay(this.tpl.builtTemplate, 'Deleting question...');
        const response = await fetch(config.deleteUrl + questionId, {
            method: 'DELETE',
            credentials: 'same-origin',
        });
        hideLoadingOverlay(this.tpl.builtTemplate);
        if (!response.ok) {
            alert(config.deleteErrorMessage || 'Unable to delete question.');
            return;
        }
        page(config.listRoute);
    }
    backToQuestions() {
        page(this.getBackRoute());
    }
    getSavePayload() {
        return this.tpl.getPayload();
    }
    getNewQuestionDefaults() {
        return {
            active: true,
            deletable: true,
            configuration: {},
            answers: [],
        };
    }
    getBackRoute() {
        return this.getConfig().listRoute;
    }
    getSavedRoute(questionId) {
        return this.getConfig().savedRoute + questionId;
    }
    getQuestionId() {
        const id = this.getVnAppZone().app.params.id;
        return id && id !== 'new' ? Number(id) : 0;
    }
    getQueryParam(name) {
        const params = new URLSearchParams(window.location.search || '');
        return params.get(name) || '';
    }
}
